import React from "react";

type Props = {
	h1_content?: string;
	h2_content?: string;
	footer_content?: string;
};

export const SeoContent = (props: Props) => {
	const { h1_content, h2_content, footer_content } = props;

	let isStructuredData = false;
	isStructuredData = footer_content?.includes("<article>") || false;

	return (
		<div className="seo-content">
			<div className="container">
				{h1_content && <h1>{h1_content}</h1>}
				{h2_content && <h2>{h2_content}</h2>}

				{footer_content && (
					<div
						className={`footer-content ${isStructuredData ? "structured-data" : ""}`}
						dangerouslySetInnerHTML={{ __html: footer_content }}
					></div>
				)}
			</div>
		</div>
	);
};

export default SeoContent;
